"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = exports.ROUTER_ERROR_EVENT_NAME = exports.ROUTER_COMPLETE_EVENT_NAME = exports.ROUTER_START_EVENT_NAME = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const styles_1 = require("./styles");
exports.ROUTER_START_EVENT_NAME = 'routeChangeStart';
exports.ROUTER_COMPLETE_EVENT_NAME = 'routeChangeComplete';
exports.ROUTER_ERROR_EVENT_NAME = 'routeChangeError';
const Loading = () => {
    const router = (0, router_1.useRouter)();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleStart = (url) => url !== router.asPath && setLoading(true);
        const handleComplete = (url) => url === router.asPath && setLoading(false);
        router.events.on(exports.ROUTER_START_EVENT_NAME, handleStart);
        router.events.on(exports.ROUTER_COMPLETE_EVENT_NAME, handleComplete);
        router.events.on(exports.ROUTER_ERROR_EVENT_NAME, handleComplete);
        return () => {
            router.events.off(exports.ROUTER_START_EVENT_NAME, handleStart);
            router.events.off(exports.ROUTER_COMPLETE_EVENT_NAME, handleComplete);
            router.events.off(exports.ROUTER_ERROR_EVENT_NAME, handleComplete);
        };
    });
    return isLoading ? react_1.default.createElement(styles_1.StyledLoading, null) : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Loading = Loading;
